namespace $.$$ {

	export class $rise_devtools_plugin extends $.$rise_devtools_plugin {

		@ $mol_mem
		keydown_listener() {
			return new this.$.$mol_dom_listener(
				this.$.$mol_dom_context.document,
				'keydown',
				this.keydown_handler,
				{ passive: false },
			)
		}

		keydown_handler = $mol_wire_async( ( event: KeyboardEvent )=> {
			console.log('devevent', event)
			if( event.defaultPrevented ) return
			if( event.code !== 'KeyC' ) return
			if( !event.ctrlKey || !event.shiftKey ) return

			event.preventDefault()
			event.stopImmediatePropagation()
			this.selecting( true )
			this.selector().reset()
		} )

		@ $mol_mem
		selector() {
			const selector = super.selector()
			selector.dom_tree()
			return selector
		}

		selector_done( event?: Event ) {
			if( event ) event.preventDefault()
			this.selector().reset()
			this.selecting( false )
			this.selector().dom_tree()
			return event ?? null
		}

	}

}
